function sendTo(_eventCategory, _eventAction, _eventLabel) {
  try {
    ga('send', {
      hitType: 'event',
      eventCategory: _eventCategory,
      eventAction: _eventAction,
      eventLabel: _eventLabel,
    });
  } catch (e) {
    var x = e;
  }
}

export default { sendTo };
